import styles from './ProgressHeaderV2.module.css';
import { RefreshIcon } from './Icons';

export default function ProgressHeaderV2({ pending, total, onReload, label }) {
    const completed = total - pending;
    const progress = total > 0 ? (completed / total) * 100 : 0;
    const allComplete = total > 0 && pending === 0;

    return (
        <div className={`${styles['progress-header-v2']} ${allComplete ? styles['celebration'] : ''}`}>
            <div className={styles['progress-header-content']}>
                <div className={styles['progress-stats']}>
                    <span className={styles['progress-counter']}>{pending}</span>
                    <div className={styles['progress-text']}>
                        <span className={styles['progress-label']}>
                            pendientes de <strong>{total}</strong>
                        </span>
                        <span className={styles['progress-sublabel']}>{label}</span>
                    </div>
                </div>

                <button
                    className={styles['reload-button-v2']}
                    onClick={onReload}
                    aria-label="Recargar pedidos"
                >
                    <RefreshIcon size={20} />
                    Recargar
                </button>
            </div>

            <div className={styles['progress-bar-container']}>
                <div
                    className={styles['progress-bar-fill']}
                    style={{ width: `${progress}%` }}
                    role="progressbar"
                    aria-valuenow={completed}
                    aria-valuemin={0}
                    aria-valuemax={total}
                />
            </div>

            {allComplete && (
                <div className={styles['celebration-message']}>
                    ¡Todos los pedidos están listos!
                </div>
            )}
        </div>
    );
}
